"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextSwitcher = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faCaretUp_1 = require("@fortawesome/free-solid-svg-icons/faCaretUp");
const faCaretDown_1 = require("@fortawesome/free-solid-svg-icons/faCaretDown");
const faCheck_1 = require("@fortawesome/pro-light-svg-icons/faCheck");
const common_1 = require("./common");
const polished_1 = require("polished");
const ContextSwitcher = ({ appContext, onChange, availableContexts }) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    const isClickable = availableContexts.length > 1;
    const onToggleVisibility = () => {
        if (!isClickable)
            return;
        setIsVisible(!isVisible);
    };
    const selectedOption = (0, common_1.getOptionByContext)(appContext);
    if (!selectedOption)
        return null;
    return ((0, jsx_runtime_1.jsxs)(Switcher, { isClickable: isClickable, children: [(0, jsx_runtime_1.jsxs)("div", { onClick: onToggleVisibility, children: [selectedOption.body, isClickable && ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: isVisible ? faCaretUp_1.faCaretUp : faCaretDown_1.faCaretDown, size: "lg" }, void 0))] }, void 0), isVisible && (0, jsx_runtime_1.jsx)(DarkLayer, { onClick: onToggleVisibility }, void 0), isVisible && ((0, jsx_runtime_1.jsx)("div", { children: common_1.options.map((option) => {
                    return ((0, jsx_runtime_1.jsx)(Option, { onClick: () => {
                            onToggleVisibility();
                            onChange(option.value);
                        }, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { children: option.body }, void 0), selectedOption.value === option.value && ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faCheck_1.faCheck }, void 0))] }, void 0) }, option.value));
                }) }, void 0))] }, void 0));
};
exports.ContextSwitcher = ContextSwitcher;
const Switcher = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  height: 3rem;
  padding: ${({ theme }) => `${theme.spacings.s} ${theme.spacings.m}`};
  position: relative;
  width: 14rem;

  & img {
    height: 2.35rem;
    width: auto;
  }

  & > div:first-of-type {
    align-items: center;
    cursor: ${({ isClickable }) => (isClickable ? "pointer" : "unset")};
    display: flex;
    justify-content: space-between;
    transform: translateY(-8px);
  }

  & > div:last-of-type:not(:first-of-type) {
    position: absolute;
    top: 3rem;
    left: 0;
    z-index: 50;

    & > div {
      padding: ${({ theme }) => `0 ${theme.spacings.m}`};
    }

    & > div:not(:last-of-type) {
      & > div {
        border-bottom: 1px solid
          ${({ theme }) => theme.colors.silverBase};
      }
    }
  }
`;
const Option = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  cursor: pointer;
  width: 14rem;

  & > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: ${({ theme }) => `${theme.spacings.s} 0`};
  }
`;
const DarkLayer = styled_components_1.default.div `
  background-color: ${({ theme }) => (0, polished_1.transparentize)(0.5, theme.colors.greyBase)};
  height: calc(100vh - 3rem);
  position: fixed;
  top: 3rem;
  left: 0;
  width: 100vw;
  z-index: 50;
`;
//# sourceMappingURL=Desktop.js.map